import gql from 'graphql-tag'


export const SEE_TOPCOMMENT = gql`
         query seeTopComment($categoryId: String!) {
           seeTopComment(categoryId: $categoryId) {
             id
             topCommentId
             makerChannelId
             makerChannelDisplayName
             makerChannelProfileImageUrl
             textOriginal
             likeCount
             videoId
             makerUpdatedAt
             makerPublishedAt
             reComment {
                 id
                 reCommentId
                 makerChannelId
                 makerChannelDisplayName
                 makerChannelProfileImageUrl
                 likeCount
                 videoId
                 makerUpdatedAt
                 makerPublishedAt
                 textOriginal
             }
           }
         }
       `;